// @flow

import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

import PassengerReview from './PassengerReview';
import CardholderReview from './CardholderReview';
import SelectedFlightReview from './SelectedFlightReview';
import FlightReviewsProvider from '../Common/FlightReviewsProvider';
import SubmitButton from './HBLSubmitButton';

import { WhitePanel } from '../../../components';
import RefreshPageModal from './RefreshPageModal';
import { trackFlightReviewView } from '../../../redux/actions/analyticsEventActions';
import {
  useDocumentTitle,
  // usePaypalScriptLoader,
} from '../../../hooks';
import {
  ReservationTimeExpiredModal,
  injectFlightSearchParams,
} from '../Common';

import './flightsummary.css';
import api from '../../../lib/api';
import { camelizeKeys } from 'humps';

type Props = RouteComponentProps & {
  trackFlightReviewView: () => void,
  isOneWay: boolean,
  isRoundTrip: boolean,
};

function ReviewScreen(props: Props) {
  const { isRoundTrip, trackFlightReviewView, match } = props;
  const { invoiceId } = match.params;
  const { invoice, lineItems, /** error **/ } = useGetInvoiceData(invoiceId);

  useDocumentTitle('Flights Details Review');

  // const isScriptLoaded = usePaypalScriptLoader();

  React.useEffect(() => {
    trackFlightReviewView();
  }, []);

  // const showRefreshModal = isScriptLoaded === false || error ? true : false;
  return (
    <ReservationTimeExpiredModal>
      <React.Fragment>
        <RefreshPageModal
          // isOpen={showRefreshModal}
        />
        <FlightReviewsProvider>
          <Container>
            <div className="flight-summary">
              <Row>
                <SelectedFlightReview type="outbound" />
                {isRoundTrip && <SelectedFlightReview type="inbound" />}
                <CustomContainer
                  title="REVIEW PASSENGER DETAILS"
                  Comp={PassengerReview}
                />
                <CustomContainer
                  title="REVIEW CARD HOLDER DETAILS"
                  Comp={CardholderReview}
                />
              </Row>
            </div>
          </Container>
          {/* {isScriptLoaded && invoice && ( */}
            <SubmitButton
              invoice={invoice}
              lineItems={lineItems}
            />
          {/* )} */}
        </FlightReviewsProvider>
      </React.Fragment>
    </ReservationTimeExpiredModal>
  );
}

function CustomContainer(props) {
  const { title, Comp } = props;

  return (
    <Col md="6">
      <WhitePanel>
        <h2>{title}</h2>
        <Comp />
      </WhitePanel>
    </Col>
  );
}

function useGetInvoiceData(id) {
  const [invoice, setInvoice] = React.useState(null);
  const [lineItems, setLineItems] = React.useState(null);

  const [error, setError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);

    api
      .get(`payments/invoices/${id}`)
      .then(({ data }) => {
        const { invoice, lineItems } = camelizeKeys(data);

        setInvoice(invoice);
        setLineItems(lineItems);
      })
      .catch(err => setError(err))
      .finally(() => setIsLoading(false));
  }, [id]);

  return { invoice, lineItems, error, isLoading };
}

export default connect(
  null,
  { trackFlightReviewView }
)(injectFlightSearchParams(ReviewScreen));



// WEBPACK FOOTER //
// ./src/screens/Flights/Review/ReviewScreen.js